/**
 * Summary Cards for Ministers List Report
 */

import { Card, CardContent } from "@/components/ui/card";
import { Users } from "lucide-react";
import type { MinistersListReportSummary } from "../types";
import { translateStatus } from "../utils/translations";

interface SummaryCardsProps {
  summary: MinistersListReportSummary;
  isLoading?: boolean;
}

export function SummaryCards({ summary, isLoading = false }: SummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="space-y-4">
        {[...Array(2)].map((_, i) => (
          <Card key={i}>
            <CardContent className="p-6">
              <div className="h-20 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Total Ministers */}
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Total Ministros
              </p>
              <p className="text-3xl font-bold">{summary.totalMinisters}</p>
              <p className="mt-1 text-xs text-muted-foreground">
                {summary.activeUniqueMinisters} personas únicas activas
              </p>
              {summary.uniqueMinisters > summary.activeUniqueMinisters && (
                <p className="mt-0.5 text-xs text-amber-600">
                  +{summary.uniqueMinisters - summary.activeUniqueMinisters} inactivados después de credencializar
                </p>
              )}
            </div>
            <Users className="size-8 text-primary" />
          </div>
        </CardContent>
      </Card>

      {/* Status Breakdown */}
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="w-full">
              <p className="mb-3 text-sm font-medium text-muted-foreground">
                Total de Ministros por Estado de Solicitud
              </p>
              <div className="space-y-2">
                {summary.byStatus.map((s: { status: string; count: number }, i: number) => (
                  <div key={i} className="flex items-center justify-between">
                    <span className="text-sm text-muted-foreground">
                      {translateStatus(s.status)}
                    </span>
                    <span className="text-sm font-semibold">{s.count}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
